import { render } from "./explainer.vue?vue&type=template&id=0189815c"
import script from "./explainer.vue?vue&type=script&lang=js"
export * from "./explainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/minify-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__